export class LazyMap {
    _eventManager;
    _map;
    _onLoad = [];
    constructor(eventManager) {
        this._eventManager = eventManager;
        this._eventManager.on("hv-map-created", (map) => {
            this._map = map;
            this.invoke(map);
        });
    }
    invoke(map) {
        this._onLoad.forEach((callback) => {
            callback(map);
        });
    }
    onLoad(callback) {
        this._onLoad.push(callback);
        if (this._map !== undefined) {
            this.invoke(this._map);
        }
    }
}
//# sourceMappingURL=LazyMap.js.map